// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// // import conditionsData from '../../conditiondata.json';
// import conditionsData from '../../conditions.json'

// const ConditionsGrid = ({ query = '' }) => {
//   const navigate = useNavigate();
// // console.log(conditionsData.conditions,"this is")
//   const filtered = conditionsData.conditions?.conditions.filter(c =>
//     c.name.toLowerCase().includes(query.toLowerCase()) ||
//     c.description.toLowerCase().includes(query.toLowerCase())
//   );

//   return (
//     <section
//       id="conditions"
//       style={{ backgroundColor: '#F4F6FA' }}
//       className="w-full py-0.5 px-4 sm:px-6"
//     >
//       <div className="max-w-5xl mx-auto">
//         {filtered.length > 0 ? (
//           <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
//             {filtered.map(condition => (
//               <div
//                 key={condition.id}
//                 className="bg-white border border-gray-100 rounded-md p-4 cursor-pointer transition-all duration-200 flex flex-col gap-2"
//                 onMouseEnter={e => {
//                   e.currentTarget.style.borderColor = 'var(--primary-color)';
//                   e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)';
//                 }}
//                 onMouseLeave={e => {
//                   e.currentTarget.style.borderColor = '#f3f4f6';
//                   e.currentTarget.style.boxShadow = 'none';
//                 }}
//                 onClick={() => navigate(`/conditions/${condition.slug}`)}
//               >
//                 {/* Icon */}
//                 <div
//                   className="w-16 h-16 ava-card-bg rounded-full flex items-center justify-center flex-shrink-0"
//                   style={{ 
//                     // backgroundColor: '#EAF1FF',
//                      color: 'var(--primary-color)' }}
//                   // dangerouslySetInnerHTML={{ __html: condition.icon }}

//                 >
//                   <img src={condition.icon} alt={condition.name} />
//                 </div>

//                 {/* Name */}
//                 <p className="ava-text-subheading">
//                   {condition.name}
//                 </p>

//                 {/* Description */}
//                 <p className="ava-text-body primary-text flex-1">
//                   {condition.description}
//                 </p>

//                 {/* Arrow button — right aligned */}
//                 <div className="flex justify-end ">
//                   <div
//                     className="w-10 h-10 ava-card-bg rounded-full flex items-center justify-center border transition-colors duration-200"
//                     style={{
//                       borderColor: 'var(--primary-color)',
//                       // backgroundColor: '#EAF1FF',
//                        color: 'var(--primary-color)'
//                     }}
//                   >
//                     <svg
//                       width="15"
//                       height="15"
//                       fill="none"
//                       stroke='var(--primary-color)'
//                       strokeWidth="2.5"
//                       viewBox="0 0 24 24"
//                     >
//                       <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
//                     </svg>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <div className="text-center py-16 text-gray-400 text-sm">
//             No conditions found. Try different keywords.
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

// export default ConditionsGrid;
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import conditionsData from "../../conditions.json";

// Pull just the icon styling out as a reusable pool, in order
const staticConditionsList = Array.isArray(conditionsData)
  ? conditionsData
  : Array.isArray(conditionsData?.conditions)
  ? conditionsData.conditions
  : Array.isArray(conditionsData?.conditions?.conditions)
  ? conditionsData.conditions.conditions
  : [];

const iconPool = staticConditionsList.length
  ? staticConditionsList.map((c) => ({
      icon: c.icon,
      iconBg: c.iconBg,
      iconColor: c.iconColor,
    }))
  : [{ icon: "/Conditions/VectorHeart.svg", iconBg: "#f4f6fa", iconColor: "var(--primary-color)" }];

// Assign icons round-robin by index — wraps back to the first icon once the pool runs out
const enrichCondition = (apiCondition, index) => {
  const iconData = iconPool[index % iconPool.length];
  return {
    ...apiCondition,
    name: apiCondition.conditionName || apiCondition.name || "",
    ...iconData,
  };
};

const ConditionsGrid = ({ query = "" }) => {
  const navigate = useNavigate();

  const [conditions, setConditions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchConditions = async () => {
      try {
        const response = await fetch(
          "https://api.avexa.net/clinic-onboarding/masters/condition-focus"
        );

        if (!response.ok) {
          throw new Error("Failed to fetch conditions");
        }

        const data = await response.json();
        setConditions(data.map(enrichCondition));
      } catch (err) {
        console.error(err);
        setError("Unable to load conditions.");
      } finally {
        setLoading(false);
      }
    };

    fetchConditions();
  }, []);

  const filtered = conditions.filter((condition) => {
    const name = condition.name || "";
    const description = condition.description || "";
    return (
      name.toLowerCase().includes(query.toLowerCase()) ||
      description.toLowerCase().includes(query.toLowerCase())
    );
  });

  if (loading) {
    return (
      <section id="conditions" style={{ backgroundColor: "#F4F6FA" }} className="w-full py-10 px-4 sm:px-6">
        <div className="max-w-5xl mx-auto text-center">Loading conditions...</div>
      </section>
    );
  }

  if (error) {
    return (
      <section id="conditions" style={{ backgroundColor: "#F4F6FA" }} className="w-full py-10 px-4 sm:px-6">
        <div className="max-w-5xl mx-auto text-center text-red-500">{error}</div>
      </section>
    );
  }

  return (
    <section id="conditions"
    //  style={{ backgroundColor: "#F4F6FA" }} 
     className="py-6 w-full py-0.5 px-4 sm:px-6 ava-card-bg">
          <h2 className="ava-heading-lg text-center mb-6">Conditions We Care For</h2>
      <div className="max-w-5xl mx-auto">
        {filtered.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
            {filtered.slice(0,8).map((condition) => (
              <div
                key={condition.id}
                className="bg-white border border-gray-100 rounded-md p-4 transition-all duration-200 flex flex-col gap-2"
                // cursor-pointer 
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "var(--primary-color)";
                  e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.08)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "#f3f4f6";
                  e.currentTarget.style.boxShadow = "none";
                }}
                // onClick={() => navigate(`/conditions/${condition.slug || condition.id}`)}
              >
                <div
                  className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: condition.iconBg, color: condition.iconColor }}
                >
                  <img src={condition.icon} alt={condition.name} className="w-6 h-6 object-contain" />
                </div>

                <p className="ava-text-subheading">{condition.name}</p>

                <p className="ava-text-body primary-text flex-1">
                  {condition.description || "No description available."}
                </p>

                <div className="flex justify-end">
                  {/* <div
                    className="w-10 h-10 ava-card-bg rounded-full flex items-center justify-center border transition-colors duration-200"
                    style={{ borderColor: "var(--primary-color)", color: "var(--primary-color)" }}
                  >
                    <svg width="15" height="15" fill="none" stroke="var(--primary-color)" strokeWidth="2.5" viewBox="0 0 24 24">
                      <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div> */}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-16 text-gray-400 text-sm">
            No conditions found. Try different keywords.
          </div>
        )}
      </div>
    </section>
  );
};

export default ConditionsGrid;